// /src/data/posts.js
import matter from "gray-matter";

// Bundle all Markdown in src/data/content/blog (no subfolders)
// NOTE: this path is RELATIVE TO THIS FILE.
const mdContext = require.context("./content/blog", false, /\.md$/);

// simple in-memory cache
let _postsCache = null;

async function loadAllPosts() {
  try {
    const keys = mdContext.keys(); // e.g. ["./my-post.md", ...]
    if (!keys.length) {
      console.warn("[posts] No markdown files found under src/data/content/blog");
    }

    const items = await Promise.all(
      keys.map(async (key) => {
        try {
          // Webpack 5 asset modules may return a URL string or { default: url }
          const mod = mdContext(key);
          const url = (mod && mod.default) ? mod.default : mod;

          if (typeof url !== "string") {
            console.error("[posts] Unexpected module shape for", key, mod);
            return null;
          }

          const slug = key.replace("./", "").replace(/\.md$/, "");
          const res = await fetch(url);
          if (!res.ok) {
            console.error("[posts] Fetch failed for", key, url, res.status);
            return null;
          }

          const raw = await res.text();
          const { data, content } = matter(raw);

          return {
            slug,
            title: data.title || slug,
            date: data.date || "",
            tags: Array.isArray(data.tags) ? data.tags : [],
            description: data.description || "",
            readTime: data.readTime || "",
            content,
          };
        } catch (err) {
          console.error("[posts] Error loading", key, err);
          return null;
        }
      })
    );

    // filter nulls and sort newest first
    const posts = items.filter(Boolean).sort((a, b) => {
      const da = a.date ? new Date(a.date).getTime() : 0;
      const db = b.date ? new Date(b.date).getTime() : 0;
      return db - da;
    });

    return posts;
  } catch (e) {
    console.error("[posts] Fatal: failed to enumerate markdown files", e);
    throw e;
  }
}

export async function getPosts() {
  if (_postsCache) return _postsCache;
  _postsCache = await loadAllPosts();
  return _postsCache;
}

export async function getPostBySlug(slug) {
  const posts = await getPosts();
  return posts.find((p) => p.slug === slug) || null;
}